import { observer } from 'mobx-react';
import BasePageLayout from '../../components/layouts/base-page-layout/base-page-layout';
import { Outlet } from 'react-router-dom';
import accountListStore from './stores/account-list-store';
import { useEffect } from 'react';
import roleStore from './stores/role-store';
import addonsStoreList from './addons-section/stores/addons-store-list';
import portalStore from '../../stores/current-portal-store';
import { FEATURES } from '../../models/Plan';

const AdminAccountPage: React.FC = observer(() => {
    useEffect(() => {
        roleStore.load();
        accountListStore.load();
        addonsStoreList.load();
        portalStore.loadFeatures([FEATURES.ADDONS]);
    }, []);

    return (
        <BasePageLayout title="Account">
            <Outlet />
        </BasePageLayout>
    );
});

export default AdminAccountPage;
